import dynamicform from "@/store/sep/dynamicform";
import dynamictable from "@/store/sep/dynamictable";
import dynamictableaddrows from "@/store/sep/dynamictableaddrows";

import { httpAPI } from "@/api/httpAPI";
const sep = {
    namespaced: true,
    state: {
        menuLoading: true,
        dataSource: null,
        OpenedIds: []
    },
    mutations: {
        SET_MENU_LOADING(state, payload) {
            state.menuLoading = payload;
        },
        SET_DATA_SOURCE(state, payload) {
            state.dataSource = payload;
        },
        CLEAR_OPENED_IDS(state) {
            state.OpenedIds = []
        },
        PUSH_OPENED_IDS(state, payload){
            if (payload)
                state.OpenedIds.push(payload);
        }
    },
    actions: {
       async getContexts({ commit }) {
            
            function getOpendElements(context, id) {
                if (context.Classifiers.find(c => c.Id == id)){
                    commit('PUSH_OPENED_IDS', context.Id);
                    return true;
                }
                if (context.ChildContexts){
                    context.ChildContexts.forEach(child => {
                        if (getOpendElements(child, id)){
                            commit('PUSH_OPENED_IDS', context.Id);
                            return true;
                        }
                    });
                }
                return false;
            }

            commit('SET_MENU_LOADING', true);
            commit('SET_DATA_SOURCE', null);
            commit('CLEAR_OPENED_IDS');
            let currentContextIdSelected = dynamictable.state.classifierId;
            let response = await httpAPI({ 
                url: `situation-center/classifiers/get-contexts`, 
                method: 'GET' 
            });

            
            if (response){
                commit('SET_DATA_SOURCE', response.data);
                response.data.forEach(d => {
                    if (getOpendElements(d, currentContextIdSelected)){
                        commit('PUSH_OPENED_IDS', d.Id);
                        return true;
                    }
                });
            }

            commit('SET_MENU_LOADING', false);

            return response;
        }
    },
    getters: {
        isMenuLoading: (s) => s.menuLoading,  
        getDataSource: (s) => s.dataSource,
        getOpened: (s) => s.OpenedIds
     },
    modules: {
        dynamicform,
        dynamictable,
        dynamictableaddrows
    }
}

export default sep;